<template>
  <div id="app">
    <AppHeader v-if="!hideHeader" :is-minimal="isMinimalHeader" />
    <main class="main-content" :class="{ 'no-header': hideHeader, 'minimal-content': isMinimalHeader, 'no-padding' : isNoPadding }">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <AppFooter />
    <DonationSlider />
    <GlobalModal />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useConfigStore } from './stores/config'
import { useUserStore } from './stores/user'
import AppHeader from './components/layout/AppHeader.vue'
import AppFooter from './components/layout/AppFooter.vue'
import DonationSlider from './components/DonationSlider.vue'
import GlobalModal from './components/GlobalModal.vue'

const route = useRoute()
const configStore = useConfigStore()
const userStore = useUserStore()

// 根据路由元信息决定是否隐藏头部
const hideHeader = computed(() => {
  return route.meta?.hideHeader === true
})

// 根据路由元信息决定是否使用简化头部
const isMinimalHeader = computed(() => {
  return route.meta?.minimalHeader === true
})

const isNoPadding = computed(() => {
  return route.meta?.noPadding === true
})

onMounted(async () => {
  // 加载站点配置
  await configStore.loadSiteConfig()
  // 初始化用户状态（从 localStorage 恢复）
  userStore.initUser()
})
</script>

<style scoped>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0;
}

.main-content {
  flex: 1;
  background: var(--glass-bg);
  width: 100%;
  margin: 0;
  padding: 60px 0 0 0;
  min-height: calc(100vh - 120px);
  position: relative;
}

.main-content.no-header {
  padding-top: 0;
}

.main-content.minimal-content {
  padding-top: 50px;
}

.main-content.no-padding {
  padding-top: 0;
}

@media (max-width: 768px) {
  .main-content {
    padding-top: 50px;
  }
}

@media (max-width: 480px) {
  .main-content {
    padding-top: 45px;
  }
}


.fade-enter-active {
  transition: opacity 0.3s ease;
}

.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}

.fade-enter-to {
  opacity: 1;
}

.fade-leave-from {
  opacity: 1;
}

/* 确保内容在过渡期间可见 */
.fade-enter-active > *,
.fade-leave-active > * {
  opacity: 1 !important;
  visibility: visible !important;
}
</style>